import { RouterProvider, createRouter } from '@tanstack/react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import * as TanStackQueryProvider from '@/integrations/tanstack-query/root-provider.tsx'

// Import the generated route tree
import { routeTree } from '@/routeTree.gen'

import '@/i18n'
import reportWebVitals from '@/reportWebVitals.ts'
import '@/styles.css'
import { startMocksServer } from '@/services/mocks/utils.ts'
import { AuthProvider } from '@/contexts/AuthContext.tsx'
import { NotFoundPage } from '@/pages/NotFoundPage.tsx'

// Create a new router instance

const TanStackQueryProviderContext = TanStackQueryProvider.getContext()
const router = createRouter({
  routeTree,
  context: {
    ...TanStackQueryProviderContext,
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  defaultNotFoundComponent: NotFoundPage,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const bootstrap = async () => {
  if (import.meta.env.VITE_ENABLE_MOCKS === 'true') {
    await startMocksServer()
  }

  const rootElement = document.getElementById('app')

  if (rootElement && !rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement)

    root.render(
      <StrictMode>
        <AuthProvider>
          <TanStackQueryProvider.Provider {...TanStackQueryProviderContext}>
            <RouterProvider router={router} />
          </TanStackQueryProvider.Provider>
        </AuthProvider>
      </StrictMode>,
    )
  }
}

void bootstrap()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
